import { render, staticRenderFns } from "./ResetPasswordLog.vue?vue&type=template&id=0395407b&scoped=true&"
import script from "./ResetPasswordLog.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395407b",
  null
  
)

export default component.exports